const SettlementType = {
  Oilco: "oilco",
  Dealer: "dealer",
};

export default SettlementType;
